module.exports = __webpack_public_path__ + "static/media/number5.3e15471c.svg";